<template>
    <div class="infinite-vertical-slider" ref="slider">
        <!-- Теперь у нас 3 независимых колонки -->
        <div
            v-for="colIndex in columnCount"
            :key="colIndex"
            class="slider-column"
        >
            <div
                class="column-track"
                :style="getTrackStyle(colIndex - 1)"
            >
                <div
                    class="slider-item"
                    v-for="(item, index) in getColumnItems(colIndex - 1)"
                    :key="index"
                >
                    <div class="thumbnail">
                        <img :src="item.image">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
export default {
    name: "InfiniteVerticalSlider",
    data() {
        return {
            items: window.slider || [],
            // Разные офсеты для каждой колонки
            offsets: [0, 0, 0, 0],
            // Разные скорости (например: медленная, быстрая, средняя)
            speeds: [0.3, 0.7, 0.5, 0.4],
            itemHeight: 0,
            isPaused: false,
            animationId: null,
            isMobile: false,
        };
    },
    computed: {
        columnCount() {
            return this.isMobile ? 2 : 3;
        },
        // Распределяем айтемы по 3 колонкам
        columns() {
            const cols = Array.from({ length: this.columnCount }, () => []);
            this.items.forEach((item, index) => {
                cols[index % this.columnCount].push(item);
            });
            return cols;
        }
    },
    mounted() {
        this.checkMobile();
        this.updateHeight();
        window.addEventListener('resize', this.onResize);
        this.startAnimation();
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.onResize);
        this.stopAnimation();
    },
    methods: {
        getColumnItems(index) {
            // Дублируем элементы внутри колонки для бесконечности
            return [...this.columns[index], ...this.columns[index]];
        },
        getTrackStyle(index) {

            const offset = this.offsets[index];

            return {
                transform: this.isMobile
                    ? `translate3d(-${offset}px, 0, 0)`
                    : `translate3d(0, -${offset}px, 0)`,
                willChange: 'transform'
            };
        },
        onResize() {
            const wasMobile = this.isMobile;
            this.checkMobile();

            if (wasMobile !== this.isMobile) {
                this.offsets = [0, 0, 0, 0]; // сбрасываем при смене режима
            }

            this.updateHeight();
        },
        checkMobile() {
            this.isMobile = window.innerWidth <= 992;
        },
        updateHeight() {
            this.$nextTick(() => {
                const item = this.$el.querySelector('.slider-item');
                if( ! item ) return;

                // Используем getBoundingClientRect для максимальной точности (с дробными пикселями)
                const rect = item.getBoundingClientRect();

                // ВАЖНО: Если у вас padding-bottom: 12px, то высота элемента
                // для расчета сброса должна быть: высота картинки + отступ.
                // Самый надежный способ в 2026 году — измерить расстояние между началом первого и второго элемента.
                const nextItem = this.$el.querySelector('.slider-item:nth-child(2)');
                if( nextItem ) {
                    const nextRect = nextItem.getBoundingClientRect();

                    // На мобиле измеряем по горизонтали
                    this.itemHeight = this.isMobile
                        ? nextRect.left - rect.left
                        : nextRect.top - rect.top;
                } else {
                    this.itemHeight = rect.height;
                }
            });
        },
        startAnimation() {
            const animate = () => {
                if (!this.isPaused && this.itemHeight > 0) {
                    const newOffsets = [...this.offsets];

                    for (let i = 0; i < this.columnCount; i++) {
                        const colResetPoint = this.columns[i].length * this.itemHeight;

                        if (i === 1) {
                            // ВТОРАЯ КОЛОНКА: едет вниз
                            newOffsets[i] -= this.speeds[i];
                            if (newOffsets[i] <= 0) {
                                newOffsets[i] = colResetPoint;
                            }
                        } else {
                            // ПЕРВАЯ И ТРЕТЬЯ: едут вверх
                            newOffsets[i] += this.speeds[i];
                            if (newOffsets[i] >= colResetPoint) {
                                newOffsets[i] = newOffsets[i] % colResetPoint;
                            }
                        }
                    }
                    this.offsets = newOffsets;
                }
                this.animationId = requestAnimationFrame(animate);
            };
            this.animationId = requestAnimationFrame(animate);
        },
        stopAnimation() {
            cancelAnimationFrame(this.animationId);
        },
        pause() { this.isPaused = true; },
        resume() { this.isPaused = false; }
    }
}
</script>

<style scoped lang="scss">
.infinite-vertical-slider {
    display: flex;
    width: 100%;
    height: 100%;
    overflow: hidden;
    gap: 12px; // Отступ между колонками

    // Эффект растворения краев
    mask-image: linear-gradient(to bottom, transparent, black 15%, black 85%, transparent);

    .slider-column {
        flex: 1;
        height: 100%;
    }

    .column-track {
        display: flex;
        flex-direction: column;
    }

    .slider-item {
        width: 100%;
        padding-bottom: 12px; // Отступ между картинками в колонке
        box-sizing: border-box;

        .thumbnail {
            width: 100%;
            aspect-ratio: 1 / 1;
            border-radius: 16px;
            overflow: hidden;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                display: block;
            }
        }
    }
    @media (max-width: 992px) {
        &.infinite-vertical-slider {
            flex-direction: column; // строки вместо колонок
        }

        .slider-column {
            width: 100%;
            height: auto;
            flex: none;
        }

        .column-track {
            flex-direction: row; // айтемы идут горизонтально
        }

        .slider-item {
            flex-shrink: 0;
            width: 180px;
            padding-bottom: 0;
            padding-right: 20px;
        }

        // Маска по горизонтали
        mask-image: linear-gradient(to right, transparent, black 15%, black 85%, transparent);
    }
}
</style>